module.exports = __webpack_public_path__ + "static/media/printer.fd2de559.gif";